/**
 * VolumeControl — mute toggle + level rail.
 *
 * State lives in RadioContext (`volume` 0-100, `isMuted`) and is applied to the
 * audio element as `isMuted ? 0 : volume / 100`, identical to v2. The fill is
 * driven by the `--dmr-fill` custom property so the gradient tracks the value
 * without inline style churn.
 */

import React from 'react';
import { Volume2, VolumeX } from 'lucide-react';

export default function VolumeControl({ volume, isMuted, onChange, onToggleMute, compact = false }) {
  const effective = isMuted ? 0 : volume;

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={onToggleMute}
        aria-label={isMuted ? 'Unmute' : 'Mute'}
        aria-pressed={isMuted}
        data-testid="mute-button"
        className="text-[#00FF41] transition-colors hover:text-[#00FF41]/70"
      >
        {isMuted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
      </button>

      <input
        type="range"
        min="0"
        max="100"
        value={effective}
        onChange={(event) => onChange(parseInt(event.target.value, 10))}
        className={`dmr-range ${compact ? '!w-20' : ''}`}
        style={{ '--dmr-fill': `${effective}%` }}
        aria-label="Volume"
        data-testid="volume-slider"
      />

      {!compact && (
        <span className="w-8 text-xs text-[#404040] tabular-nums">{effective}%</span>
      )}
    </div>
  );
}
